export function dialogTrigger(element = document.activeElement) {
    const panel = element?.closest?.(".cell-popover__panel");
    if (panel?.id) {
        const trigger = document.querySelector(`[aria-controls="${panel.id}"]`);
        if (trigger) return trigger;
    }
    return (
        element?.closest?.(".dropdown, .dropend")?.querySelector('[data-bs-toggle="dropdown"]') ||
        element
    );
}

export function useDialogFocus(fallback = "main h1") {
    let trigger = null;

    function capture() {
        trigger = dialogTrigger();
    }

    function focusFirst(id) {
        const dialog = document.getElementById(id);
        dialog?.focus({ preventScroll: true });
    }

    function restore() {
        const target =
            trigger?.isConnected && trigger.getClientRects().length
                ? trigger
                : document.querySelector(fallback);
        if (!target) return;
        if (!target.matches("button, input, select, textarea, a, [tabindex]")) {
            target.setAttribute("tabindex", "-1");
        }
        target.focus();
    }

    return { capture, focusFirst, restore };
}
